<template>
  <div class="register-download-page">
    <video
      v-if="currentVideoSrc"
      class="bg-video"
      :src="currentVideoSrc"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
    />
    <img class="bg-mask" :src="maskingImg" alt="" />

    <div class="page-content">
      <div class="top-bubbles">
        <p class="bubble">注册进来找我吧</p>
        <p class="bubble">我在圈内等你</p>
      </div>

      <div
        v-if="!registerCompleted"
        class="register-card-wrap"
        :style="{ backgroundImage: `url(${registerBgImg})` }"
      >
        <section class="register-card">
          <form class="register-form" @submit.prevent="handleRegister">
            <div class="form-row">
              <span class="form-label">手机号</span>
              <span class="form-divider" aria-hidden="true" />
              <input
                v-model.trim="loginPhone"
                class="form-input"
                type="tel"
                maxlength="11"
                placeholder="输入手机号"
                autocomplete="tel"
              />
            </div>
            <div class="form-row form-row-code">
              <span class="form-label">验证码</span>
              <span class="form-divider" aria-hidden="true" />
              <input
                v-model.trim="phoneCode"
                class="form-input"
                type="text"
                maxlength="6"
                placeholder="输入验证码"
                autocomplete="one-time-code"
              />
              <button
                type="button"
                class="send-code-btn"
                :disabled="sendCodeDisabled"
                @click="handleSendCode"
              >
                {{ sendCodeText }}
              </button>
            </div>
            <button
              type="submit"
              class="register-submit-btn"
              :disabled="registerLoading || !groupCode"
            >
              <img
                class="register-submit-bg"
                :src="registerBtnImg"
                alt="注册"
              />
            </button>
          </form>
        </section>
      </div>

      <div
        v-if="registerCompleted"
        class="download-card-wrap"
        :style="{ backgroundImage: `url(${downloadBgImg})` }"
      >
        <section class="download-card">
          <div class="card-actions">
            <div class="action-item">
              <button type="button" class="action-btn" @click="goToMobileWeb">
                <span class="action-btn-text">手机网页版</span>
              </button>
              <p class="action-hint">
                <span>不等了,直接游玩</span>
                <img class="hint-icon" :src="iconH5Img" alt="" />
              </p>
            </div>
            <div class="action-item">
              <button type="button" class="action-btn" @click="goToAndroid">
                <span class="action-btn-text">Android</span>
              </button>
              <p class="action-hint">
                <span>我先下载，细细评鉴</span>
                <img class="hint-icon" :src="iconAndroidImg" alt="" />
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import maskingImg from "@/assets/register-download/masking.png";
import registerBgImg from "@/assets/register-download/register_bg.png";
import downloadBgImg from "@/assets/register-download/download_bg.png";
import registerBtnImg from "@/assets/register-download/register_btn.png";
import iconH5Img from "@/assets/register-download/icon_h5.png";
import iconAndroidImg from "@/assets/register-download/icon_android.png";
import { loginOrRegister, sendVerifyCode, getAndroidUrl } from "@/config/api";

const SEND_CODE_COUNTDOWN = 60;

const VIDEO_FILES = [
  "1.mp4",
  "2.mp4",
  "3.mp4",
  "4.mp4",
  "5.mp4",
  "6.mp4",
  "7.mp4",
  "8.mp4",
  "9.mp4",
  "10.mp4",
  "11.mp4",
  "12.mp4",
  "13.mp4",
];

export default {
  name: "RegisterDownload",
  data() {
    return {
      H5_url: "https://mp.haiquan.fun",
      android_url: "",
      androidUrl: "",
      currentVideoSrc: "",
      registerCompleted: false,
      groupCode: "",
      loginPhone: "",
      phoneCode: "",
      registerLoading: false,
      codeCountdown: 0,
      codeSending: false,
      countdownTimer: null,
      maskingImg,
      registerBgImg,
      downloadBgImg,
      registerBtnImg,
      iconH5Img,
      iconAndroidImg,
    };
  },
  computed: {
    sendCodeDisabled() {
      return (
        !this.groupCode ||
        this.codeSending ||
        this.codeCountdown > 0 ||
        !/^1\d{10}$/.test(this.loginPhone)
      );
    },
    sendCodeText() {
      if (this.codeCountdown > 0) {
        return `${this.codeCountdown}s`;
      }
      return "获取验证码";
    },
  },
  created() {
    this.fetchAndroidUrl();
    const index = Math.floor(Math.random() * VIDEO_FILES.length);
    this.currentVideoSrc = `/mp4/${VIDEO_FILES[index]}`;
    const rawQuery = this.$route.query;
    const bareCode = Object.keys(rawQuery).find(k => k && !rawQuery[k]) || "";
    this.groupCode = String(
      this.$route.params.groupCode || rawQuery.groupCode || bareCode
    ).trim();
    // if (!this.groupCode) {
    //   this.$message.warning("缺少邀请码，无法注册");
    // }
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    startCountdown() {
      this.clearCountdown();
      this.codeCountdown = SEND_CODE_COUNTDOWN;
      this.countdownTimer = setInterval(() => {
        if (this.codeCountdown <= 1) {
          this.codeCountdown = 0;
          this.clearCountdown();
          return;
        }
        this.codeCountdown -= 1;
      }, 1000);
    },
    async handleSendCode() {
      // if (!this.groupCode) {
      //   this.$message.warning("缺少邀请码，无法注册");
      //   return;
      // }
      if (!/^1\d{10}$/.test(this.loginPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      this.codeSending = true;
      try {
        const res = await sendVerifyCode(this.loginPhone);
        if (res && (res.code === 200 || res.code === 0 || res.success)) {
          this.$message.success(res.msg || "验证码已发送");
          this.startCountdown();
        } else {
          this.$message.error((res && res.msg) || "发送验证码失败");
        }
      } catch (e) {
        this.$message.error("发送验证码失败，请稍后重试");
      } finally {
        this.codeSending = false;
      }
    },
    async handleRegister() {
      // if (!this.groupCode) {
      //   this.$message.warning("缺少邀请码，无法注册");
      //   return;
      // }
      if (!/^1\d{10}$/.test(this.loginPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.phoneCode) {
        this.$message.warning("请输入验证码");
        return;
      }
      this.registerLoading = true;
      try {
        const res = await loginOrRegister({
          loginPhone: this.loginPhone,
          phoneCode: this.phoneCode,
          groupCode: this.groupCode,
        });
        if (res && res.code == 200) {

          const token = res.data.token;
          if (token) {
            localStorage.setItem("token", token);
          }
          this.$message.success(res.msg || "注册成功");
          this.registerCompleted = true;
          this.fetchAndroidUrl();
        } else {
          this.$message.error((res && res.msg) || "注册失败");
        }
      } catch (e) {
        this.$message.error("注册失败，请稍后重试");
      } finally {
        this.registerLoading = false;
      }
    },
    goToMobileWeb() {
      const url = new URL(this.H5_url);
      if (this.groupCode) {
        url.searchParams.set("groupCode", this.groupCode);
      }
      window.location.href = url.toString();
    },
    async fetchAndroidUrl() {
      console.log("🚀 ~ fetchAndroidUrl");
      try {
        const res = await getAndroidUrl();
        console.log("🚀 ~ res:", res);
        if (res && res.code === 200 && res.data) {
          this.androidUrl = res.data;
        } else {
          this.androidUrl = this.android_url;
        }
      } catch (e) {
        this.androidUrl = this.android_url;
      }
    },
    goToAndroid() {
      const url = this.androidUrl || this.android_url;
      const a = document.createElement("a");
      a.href = url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style scoped>
.register-download-page {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Segoe UI",
    "Roboto", sans-serif;
}

.bg-video,
.bg-mask {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.bg-video {
  z-index: 0;
}

.bg-mask {
  z-index: 1;
}

.page-content {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: calc(88px + env(safe-area-inset-top, 0px))
    max(14px, env(safe-area-inset-right, 0px))
    calc(24px + env(safe-area-inset-bottom, 0px))
    max(14px, env(safe-area-inset-left, 0px));
}

.register-card-wrap {
  position: relative;
  width: 100%;
  max-width: min(370px, calc(100vw - 28px));
  min-width: 0;
  aspect-ratio: 778 / 702;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.register-card {
  position: absolute;
  top: 32%;
  right: 11.5%;
  bottom: 10%;
  left: 11.5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  overflow: hidden;
}

.register-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0 10px;
  box-shadow: border-box;
}

.form-row {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
  padding: 0 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(143, 111, 214, 0.12);
}

.form-label {
  flex-shrink: 0;
  width: 52px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.form-divider {
  flex-shrink: 0;
  width: 1px;
  height: 18px;
  margin-right: 8px;
  background: #e8e8e8;
}

.form-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #333;
  font-size: 14px;
}

.form-input::placeholder {
  color: #bbb;
}

.form-row-code .form-input {
  margin-right: 6px;
}

.send-code-btn {
  flex-shrink: 0;
  min-width: 72px;
  height: 28px;
  padding: 0 8px;
  border: none;
  border-radius: 6px;
  background: #b48cf5;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 28px;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.send-code-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.register-submit-btn {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.register-submit-btn:active:not(:disabled) {
  opacity: 0.92;
  transform: scale(0.98);
}

.register-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.register-submit-bg {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}

.top-bubbles {
  position: absolute;
  top: 162px;
  left: 20px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: calc(100% - 28px);
}

.bubble {
  margin: 0;
  padding: 8px 18px;
  border: 1px solid rgba(186, 154, 255, 0.75);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.58);
  color: #8f6fd6;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  white-space: nowrap;
  box-shadow: 0 2px 12px rgba(143, 111, 214, 0.12);
}

.download-card-wrap {
  position: relative;
  width: 100%;
  max-width: min(370px, calc(100vw - 28px));
  min-width: 0;
  aspect-ratio: 778 / 523;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.download-card {
  position: absolute;
  top: 36%;
  right: 11.5%;
  bottom: 20%;
  left: 11.5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 2px 6px;
  overflow: hidden;
}

.card-actions {
  display: flex;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.action-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.action-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 2px;
  border: none;
  outline: none;
  border-radius: 5px;
  background: linear-gradient(90deg, #9f84fc 0%, #7337f2 100%);
  box-shadow: 0 2px 8px rgba(147, 51, 234, 0.28);
  cursor: pointer;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

.action-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
      ellipse 28% 80% at 12% 50%,
      rgba(255, 255, 255, 0.22) 0%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 28% 80% at 88% 50%,
      rgba(255, 255, 255, 0.18) 0%,
      transparent 100%
    );
  pointer-events: none;
}

.action-btn-text {
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(76, 29, 149, 0.4);
}

.action-btn:active {
  opacity: 0.92;
  transform: scale(0.98);
}

.action-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
  margin: 5px 0 0;
  color: #7e5fd4;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
}

.action-hint span {
  min-width: 0;
}

.hint-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  object-fit: contain;
}

@media (min-width: 390px) {
  .page-content {
    gap: 20px;
    padding-left: max(20px, env(safe-area-inset-left, 0px));
    padding-right: max(20px, env(safe-area-inset-right, 0px));
  }

  .bubble {
    font-size: 15px;
    padding: 9px 20px;
  }

  .register-card {
    top: 31%;
    bottom: 9%;
  }

  .form-row {
    height: 42px;
    margin-bottom: 12px;
  }

  .send-code-btn {
    min-width: 80px;
    font-size: 12px;
  }

  .download-card-wrap {
    width: 100%;
    max-width: 370px;
  }

  .download-card {
    top: 40%;
    right: 11%;
    bottom: 18.5%;
    left: 11%;
    padding-bottom: 8px;
  }

  .card-actions {
    gap: 12px;
  }

  .action-btn {
    height: 36px;
  }

  .action-btn-text {
    font-size: 13px;
  }

  .action-hint {
    font-size: 11px;
    margin-top: 6px;
  }

  .hint-icon {
    width: 18px;
    height: 18px;
  }
}
</style>
